module.exports = __SPARKY_LIBS__.PanWDSTailwindcssV10;